export default __webpack_public_path__ + "static/media/lamp8.3dcc206b.webp";